import { FC } from 'react'

import { IconButton } from '@/compositions/@buttons/IconButton/IconButton'
import { trans } from '@/helpers/trans'

import './BackButton.scss'

interface BackButtonProps {
    onClick?: () => void
    className?: string
}

export const BackButton: FC<BackButtonProps> = ({ onClick, className = '' }) => (
    <IconButton
        icon="chevron-left"
        text={trans('common.back')}
        onClick={onClick}
        className={`back-button ${className}`}
        iconClassName="back-button__icon"
    />
)
